module.exports = __webpack_public_path__ + "static/img/img-kjxzxqy-good-09.bf4f62a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-kjxzxqy-good-09.jpg
// module id = Ig8j
// module chunks = 1